import React from 'react';
import styled from 'styled-components';
import { ButtonText, Checkbox } from 'components';
import { lineHeight, theme, toRem } from 'design';
import { Text } from '../Typography';

const CheckboxRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-top: ${toRem(theme.space.sm)};
  align-items: center;

  label {
    margin-right: ${toRem(theme.space.sm)};
  }

  input {
    margin-right: ${toRem(theme.space.xs)};
  }
`;

const SelectAllButton = styled(ButtonText)`
  white-space: nowrap;
  font-size: ${toRem(theme.font.size.xs)};
  line-height: ${lineHeight(theme.font.size.xs)};
  margin-left: ${toRem(theme.space.sm)};
  color: ${theme.color.primary[500]};

  @media (min-width: ${theme.breakpoint.large}px) {
    display: block;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  width: auto;
  height: ${toRem(40)};
  margin-left: ${toRem(theme.space.sm)};
  text-transform: capitalize;

  @media (min-width: ${theme.breakpoint.large}px) {
    height: auto;
  }
`;

const PaymentStatusLabel = styled(Text).attrs({
  as: 'label',
})`
  font-size: ${toRem(theme.font.size.xxs)};
  line-height: ${lineHeight(theme.font.size.xxs)};
  font-weight: ${theme.font.weight.medium};
  display: none;

  @media (min-width: ${theme.breakpoint.large}px) {
    font-size: ${toRem(theme.font.size.sm)};
    line-height: ${lineHeight(theme.font.size.sm)};
    color: ${theme.color.neutral[500]};
    white-space: nowrap;
    display: block;
  }
`;

interface IStatusCheckboxProps {
  label: string;
  statuses: string[];
  activeStatus: string[];
  selectAll?: boolean;
  onChange(selectedStatus: string[]): void;
}

export const StatusCheckbox = ({ label, statuses, activeStatus, selectAll = true, onChange }: IStatusCheckboxProps) => {
  const onToggleCheckbox = (value: string, checked: boolean) => {
    let status;
    if (checked === true) {
      status = [...activeStatus, value];
    } else {
      status = activeStatus.filter((val) => val !== value);
    }
    onChange(status);
  };

  const onSelectAll = () => {
    onChange(statuses);
  };

  const onDeselectAll = () => {
    onChange([]);
  };

  return (
    <CheckboxRow>
      <PaymentStatusLabel>{label}</PaymentStatusLabel>
      {statuses.map((value) => (
        <StyledCheckbox
          id={`status-checkbox-${value}`}
          name={`status-checkbox-${value}`}
          key={`status-checkbox-${value}`}
          data-cy={`status-checkbox-${value}`}
          label={value}
          size="small"
          checked={activeStatus.includes(value)}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            onToggleCheckbox(value, e.target.checked);
          }}
        />
      ))}
      {selectAll &&
        (activeStatus.length === statuses.length ? (
          <SelectAllButton
            label="Deselect All"
            onClick={() => {
              onDeselectAll();
            }}
          />
        ) : (
          <SelectAllButton
            label="Select All"
            onClick={() => {
              onSelectAll();
            }}
          />
        ))}
    </CheckboxRow>
  );
};
